// extracted by css-extract-rspack-plugin
export default {"cls1":"SortPanel-cls1_pCA","cls2":"SortPanel-cls2__xV SortPanel-cls1_pCA"};